var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	42045: {
		fallback: () => (Promise.all([__webpack_require__.e(215), __webpack_require__.e(9439), __webpack_require__.e(6795), __webpack_require__.e(8454), __webpack_require__.e(2076), __webpack_require__.e(6682)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 6682))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	30215: {
		fallback: () => (Promise.all([__webpack_require__.e(6077), __webpack_require__.e(314), __webpack_require__.e(3365)]).then(() => (() => (__webpack_require__(/*! rxjs */ 93365))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	39439: {
		fallback: () => (Promise.all([__webpack_require__.e(6077), __webpack_require__.e(314), __webpack_require__.e(3555)]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 23555))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	18204: {
		fallback: () => (Promise.all([__webpack_require__.e(215), __webpack_require__.e(2395)]).then(() => (() => (__webpack_require__(/*! @angular/common */ 2395))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	14880: {
		fallback: () => (Promise.all([__webpack_require__.e(215), __webpack_require__.e(9439), __webpack_require__.e(8204), __webpack_require__.e(7026)]).then(() => (() => (__webpack_require__(/*! @angular/forms */ 67026))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.8",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",

	},
	71496: {
		fallback: () => (Promise.all([__webpack_require__.e(215), __webpack_require__.e(9439), __webpack_require__.e(5804)]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 5804))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	70135: {
		fallback: () => (Promise.all([__webpack_require__.e(9315), __webpack_require__.e(5109), __webpack_require__.e(99)]).then(() => (() => (__webpack_require__(/*! @ngxs/store */ 30099))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.1.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngxs/store",

	},
	28753: {
		fallback: () => (Promise.all([__webpack_require__.e(2952), __webpack_require__.e(1900)]).then(() => (() => (__webpack_require__(/*! @angular/router */ 61900))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	75989: {
		fallback: () => (Promise.all([__webpack_require__.e(9439), __webpack_require__.e(6795), __webpack_require__.e(8454), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 37140))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	},
	65109: {
		fallback: () => (__webpack_require__.e(6563).then(() => (() => (__webpack_require__(/*! @ngxs/store/operators */ 96563))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.1.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngxs/store/operators",

	},
	3000: {
		fallback: () => (__webpack_require__.e(121).then(() => (() => (__webpack_require__(/*! xlsx */ 60121))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.20.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "xlsx",

	},
	4394: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @ngx-translate/http-loader */ 27155))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^16.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngx-translate/http-loader",

	},
	22433: {
		fallback: () => (Promise.all([__webpack_require__.e(6565), __webpack_require__.e(5705), __webpack_require__.e(5433), __webpack_require__.e(6085), __webpack_require__.e(2183), __webpack_require__.e(4479), __webpack_require__.e(7753), __webpack_require__.e(9415), __webpack_require__.e(1673), __webpack_require__.e(5463), __webpack_require__.e(2351), __webpack_require__.e(5731)]).then(() => (() => (__webpack_require__(/*! @angular/material/menu */ 5731))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/menu",

	},
	22850: {
		fallback: () => (__webpack_require__.e(7783).then(() => (() => (__webpack_require__(/*! @ngx-translate/core */ 77783))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^16.0.4",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngx-translate/core",

	},
	25100: {
		fallback: () => (__webpack_require__.e(726).then(() => (() => (__webpack_require__(/*! @abacritt/angularx-social-login */ 726))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.6.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@abacritt/angularx-social-login",

	},
	25391: {
		fallback: () => (__webpack_require__.e(8580).then(() => (() => (__webpack_require__(/*! posthog-js */ 18580))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.375.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "posthog-js",

	},
	51888: {
		fallback: () => (__webpack_require__.e(3847).then(() => (() => (__webpack_require__(/*! date-fns */ 33847))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "date-fns",

	},
	59275: {
		fallback: () => (Promise.all([__webpack_require__.e(6565), __webpack_require__.e(5705), __webpack_require__.e(5433), __webpack_require__.e(6085), __webpack_require__.e(2183), __webpack_require__.e(4479), __webpack_require__.e(7753), __webpack_require__.e(1673), __webpack_require__.e(2351), __webpack_require__.e(8938), __webpack_require__.e(4003)]).then(() => (() => (__webpack_require__(/*! @angular/material/snack-bar */ 84976))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/snack-bar",

	},
	67288: {
		fallback: () => (Promise.all([__webpack_require__.e(244), __webpack_require__.e(2790)]).then(() => (() => (__webpack_require__(/*! ag-grid-enterprise */ 82790))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^34.3.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ag-grid-enterprise",

	},
	97095: {
		fallback: () => (Promise.all([__webpack_require__.e(2952), __webpack_require__.e(5889)]).then(() => (() => (__webpack_require__(/*! angulartics2 */ 35889))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^14.1.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "angulartics2",

	},
	12952: {
		fallback: () => (Promise.all([__webpack_require__.e(8204), __webpack_require__.e(1496), __webpack_require__.e(5010), __webpack_require__.e(2241)]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 62241))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.8",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	23421: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 15539))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	92997: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 10185))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	86565: {
		fallback: () => (__webpack_require__.e(9790).then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 37409))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/bidi",

	},
	55705: {
		fallback: () => (Promise.all([__webpack_require__.e(215), __webpack_require__.e(9439), __webpack_require__.e(8204), __webpack_require__.e(2076), __webpack_require__.e(9338)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 53197))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/layout",

	},
	5433: {
		fallback: () => (Promise.all([__webpack_require__.e(2076), __webpack_require__.e(1504)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 5831))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/coercion",

	},
	56085: {
		fallback: () => (Promise.all([__webpack_require__.e(215), __webpack_require__.e(9439), __webpack_require__.e(8204), __webpack_require__.e(2952), __webpack_require__.e(7441), __webpack_require__.e(3978), __webpack_require__.e(1860)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 10075))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/a11y",

	},
	42183: {
		fallback: () => (Promise.all([__webpack_require__.e(8204), __webpack_require__.e(2076), __webpack_require__.e(2017)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 86450))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/platform",

	},
	14479: {
		fallback: () => (__webpack_require__.e(9879).then(() => (() => (__webpack_require__(/*! @angular/cdk/private */ 42260))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/private",

	},
	29415: {
		fallback: () => (__webpack_require__.e(9202).then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 99202))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/keycodes",

	},
	21673: {
		fallback: () => (__webpack_require__.e(9061).then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 19061))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/portal",

	},
	75463: {
		fallback: () => (Promise.all([__webpack_require__.e(8204), __webpack_require__.e(7484)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 37484))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/scrolling",

	},
	42351: {
		fallback: () => (Promise.all([__webpack_require__.e(8204), __webpack_require__.e(7484), __webpack_require__.e(9061), __webpack_require__.e(6887), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 37029))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/overlay",

	},
	40761: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers/private */ 98074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/observers/private",

	},
	98455: {
		fallback: () => (Promise.all([__webpack_require__.e(215), __webpack_require__.e(7830)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/collections */ 27830))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/collections",

	},
	4902: {
		fallback: () => (Promise.all([__webpack_require__.e(8204), __webpack_require__.e(2952), __webpack_require__.e(7484), __webpack_require__.e(9061), __webpack_require__.e(6887), __webpack_require__.e(7441), __webpack_require__.e(683)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/dialog */ 90683))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/dialog",

	},
	56967: {
		fallback: () => (Promise.all([__webpack_require__.e(2076), __webpack_require__.e(9135)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/accordion */ 80359))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/accordion",

	},
	35115: {
		fallback: () => (__webpack_require__.e(2467).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers */ 14848))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/observers",

	},
	93889: {
		fallback: () => (__webpack_require__.e(6177).then(() => (() => (__webpack_require__(/*! @angular/cdk/text-field */ 66177))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/text-field",

	},
	33703: {
		fallback: () => (Promise.all([__webpack_require__.e(4880), __webpack_require__.e(3978), __webpack_require__.e(9198)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/stepper */ 59198))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/stepper",

	},
	2027: {
		fallback: () => (__webpack_require__.e(4798).then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 54798))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.8",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations/browser",

	},
	9315: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @ngxs/store/plugins */ 94100))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.1.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngxs/store/plugins",

	},
	87475: {
		fallback: () => (Promise.all([__webpack_require__.e(5989), __webpack_require__.e(8030)]).then(() => (() => (__webpack_require__(/*! @ngxs/store/internals */ 88030))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^20.1.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngxs/store/internals",

	},
	244: {
		fallback: () => (__webpack_require__.e(6606).then(() => (() => (__webpack_require__(/*! ag-grid-community */ 46606))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^34.3.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ag-grid-community",

	},
	25552: {
		fallback: () => (__webpack_require__.e(6794).then(() => (() => (__webpack_require__(/*! file-saver */ 46794))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "file-saver",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"99": [
		87475
	],
	"135": [
		70135
	],
	"215": [
		30215
	],
	"244": [
		244
	],
	"333": [
		3000,
		4394,
		22433,
		22850,
		25100,
		25391,
		51888,
		59275,
		67288,
		97095
	],
	"761": [
		40761
	],
	"1437": [
		93889
	],
	"1496": [
		71496
	],
	"1673": [
		21673
	],
	"2027": [
		2027
	],
	"2045": [
		42045
	],
	"2183": [
		42183
	],
	"2351": [
		42351
	],
	"2952": [
		12952
	],
	"4414": [
		4902
	],
	"4479": [
		14479
	],
	"4880": [
		14880
	],
	"5109": [
		65109
	],
	"5115": [
		35115
	],
	"5433": [
		5433
	],
	"5463": [
		75463
	],
	"5552": [
		25552
	],
	"5705": [
		55705
	],
	"5989": [
		75989
	],
	"6085": [
		56085
	],
	"6565": [
		86565
	],
	"7009": [
		56967
	],
	"8204": [
		18204
	],
	"8454": [
		23421,
		92997
	],
	"8455": [
		98455
	],
	"8753": [
		28753
	],
	"8869": [
		33703
	],
	"9315": [
		9315
	],
	"9415": [
		29415
	],
	"9439": [
		39439
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}